import React from 'react';

const svgClass = 'w-full h-full opacity-[0.15]';

function OpenBookIcon() {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClass}
    >
      <path
        d="M8 14C8 10 14 9 32 18C50 9 56 10 56 14V50C56 46 50 45 32 54C14 45 8 46 8 50V14Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path d="M32 18V54" stroke="currentColor" strokeWidth="1.25" fill="none" />
      <path d="M14 22H26M14 28H24M14 34H26" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
      <path d="M38 22H50M40 28H50M38 34H50" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function GeometricStarIcon() {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClass}
    >
      <path
        d="M32 4L37.5 24.5L58 30L37.5 35.5L32 56L26.5 35.5L6 30L26.5 24.5L32 4Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M32 12L34.8 26.2L48 28L34.8 29.8L32 44L29.2 29.8L16 28L29.2 26.2L32 12Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="30" r="4" fill="currentColor" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}

function ArchwayIcon() {
  return (
    <svg
      viewBox="0 0 64 80"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClass}
    >
      <path
        d="M10 72V34C10 14 20 6 32 6C44 6 54 14 54 34V72"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M18 72V38C18 22 24 14 32 14C40 14 46 22 46 38V72"
        fill="currentColor"
        fillOpacity="0.35"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path d="M12 72H52" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" fill="none" />
      <path d="M22 72V58H42V72" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" />
      <path d="M28 6L32 2L36 6" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export default function ThematicBackground() {
  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true">
      <div className="hidden lg:block absolute top-32 -left-12 w-64 h-64 rotate-12 text-[#c9a84c]">
        <OpenBookIcon />
      </div>

      <div className="hidden lg:block absolute top-[40%] -right-16 w-80 h-80 -rotate-12 text-[#c9a84c]">
        <GeometricStarIcon />
      </div>

      <div className="hidden lg:block absolute bottom-24 -left-16 w-72 h-96 rotate-6 text-[#c9a84c]">
        <ArchwayIcon />
      </div>
    </div>
  );
}
